<template>
  <div class="local-infos dbox">
    <!-- <div class="dbox-form">
     <div class="dbox-form--group">
       <div class="dbox-form--label">Doors Open</div>
       <div class="dbox-form--value">
         <input
           @blur.stop.prevent="e => onTextboxBlur(e, 'doors_open')"
           :value="booking.cdate.doors_open"
           type="text"
           class="dbox-form--input v2"
           name="doors_open"
           id="doors_open"
         />
       </div>
     </div>
     <div class="dbox-form--group">
       <div class="dbox-form--label">Curfew</div>
       <div class="dbox-form--value">
         <input
           @blur.stop.prevent="e => onTextboxBlur(e, 'curfew')"
           :value="booking.cdate.curfew"
           type="text"
           class="dbox-form--input v2"
           name="curfew"
           id="curfew"
         />
       </div>
     </div>
     <div class="dbox-form--group">
       <div class="dbox-form--label">Event URL/Ticket URL</div>
       <div class="dbox-form--value">
         <input
           @blur.stop.prevent="e => onTextboxBlur(e, 'event_url')"
           :value="booking.cdate.event_url"
           type="text"
           class="dbox-form--input v2"
           name="event_url"
           id="event_url"
         />
       </div>
     </div>
   </div>-->
    <TextField2 id="doors_open" :placeholder="$t('doors_open')" :label="$t('doors_open')"
      :value="booking.cdate.doors_open" @blur="e => onTextFieldValueChange(e)" lw="200px" />
    <TextField2 id="curfew" :placeholder="$t('curfew')" :label="$t('curfew')" :value="booking.cdate.curfew"
      @blur="e => onTextFieldValueChange(e)" lw="200px" />
    <TextField2 id="event_url" :placeholder="$t('event_url')" :label="$t('event_url')" :value="booking.cdate.event_url"
      @blur="e => onTextFieldValueChange(e)" lw="200px" bb="none" />
  </div>
</template>
<script>
import TextField from "@plugins/text-field/text-field";

export default {
  components: {
    TextField
  },
  props: ['booking', "selectedBookingCalendarDateId"],
  data: function () {
    return {
      models: ["Doors Open", "Curfew", "Event URL / Ticket URL"]
    };
  },
  computed: {},
  methods: {
    onTextFieldValueChange: function (e) {
      this.$emit('update', {
        item: this.booking.cdate,
        name: e.name,
        value: e.value,
      })
    },
    onTextboxBlur: function (event, name) {
      const calendarDateId = this.booking.cdate.calendar_date_id;
      const value = event.target.value;

      console.log(name, event.target.value);

      this.$emit('update', {
        item: this.booking.cdate,
        name,
        value,
      })

      // switch (name) {
      //   case "doorsOpen": {
      //     this.$emit("update_door_open", {
      //       calendarDateId,
      //       value
      //     });
      //     break;
      //   }
      //   case "curfew": {
      //     this.$emit("update_curfew", calendarDateId, value);
      //     break;
      //   }
      //   case "eventUrl": {
      //     this.$emit("update_event_url", calendarDateId, value);
      //     break;
      //   }
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.dt-input-box--container {
  display: flex;
  flex-direction: column;

  .dt-input-box--item {
    border: 1px solid transparent;

    &:not(:last-child) {
      box-shadow: 0 0.8px 0px 0.5px #c8c8c8;
      box-sizing: border-box;
    }

    .dt-input-box {
      height: 48px;

      color: var(--text-5);
    }
  }
}
</style>
